import { motion } from "framer-motion";

export const SectionHeader = ({ eyebrow, title, desc, align = "left", testid }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
      data-testid={testid}
    >
      <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
        <span className="w-8 h-px bg-gold" />
        <span className="label-eyebrow">{eyebrow}</span>
      </div>
      <h2 className="mt-6 font-heading text-white text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tighter leading-[0.95]">
        {title}
      </h2>
      {desc && <p className="mt-5 text-zinc-400 text-base md:text-lg leading-relaxed">{desc}</p>}
    </motion.div>
  );
};
